"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function ClockCircleTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'clock-circle',
        theme: 'twotone',
        nameWithTheme: 'clock-circle-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: {
                    fill: primaryColor,
                    d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm176.5 509.7l-28.6 39c-2.6 3.6-7.6 4.3-11.2 1.7L483.3 569.8c-2.1-1.5-3.3-3.9-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    fill: primaryColor,
                    d: 'M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.6-3.6 1.8-8.6-1.8-11.1z'
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'clock-circle-twotone';
var ClockCircleTwoTone = temp;
exports.default = ClockCircleTwoTone;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/lib/twotone/ClockCircleTwoTone.js
// module id = 1747
// module chunks = 0